// extracted by mini-css-extract-plugin
export default {"deactivationConfirmPage":"deactivation-confirm-page_deactivationConfirmPage__jrro6","logo":"deactivation-confirm-page_logo__i-g+X"};